import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AssessmentPage.css';

const AssessmentPage: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    playerName: '',
    playerEmail: '',
    playerPhone: '',
    grade: '',
    parentName: '',
    parentEmail: '',
    parentPhone: '',
    positions: '',
    goals: '',
    favoritePlayers: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Store form data in session storage
    sessionStorage.setItem('assessmentData', JSON.stringify(formData));
    
    // Redirect to the neutral test
    navigate('/football-iq-test');
  };

  return (
    <div className="assessment-page-dark">
      <div className="assessment-container-dark">
        <div className="assessment-header-dark">
          <h1>PLAYER ASSESSMENT</h1>
          <p>Complete this form to begin your IX Test evaluation. Coach Mesa will review your results and contact you within 48 hours.</p>
        </div>

        <form onSubmit={handleSubmit} className="assessment-form-dark">
          {/* Player Information */}
          <div className="form-section-dark">
            <h2>Player Information</h2>
            <div className="form-grid-dark">
              <div className="form-group-dark">
                <label htmlFor="playerName">Full Name *</label>
                <input
                  type="text"
                  id="playerName"
                  name="playerName"
                  value={formData.playerName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group-dark">
                <label htmlFor="playerEmail">Email *</label>
                <input
                  type="email"
                  id="playerEmail"
                  name="playerEmail"
                  value={formData.playerEmail}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group-dark">
                <label htmlFor="playerPhone">Phone *</label>
                <input
                  type="tel"
                  id="playerPhone"
                  name="playerPhone"
                  value={formData.playerPhone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group-dark">
                <label htmlFor="grade">Grade *</label>
                <select
                  id="grade"
                  name="grade"
                  value={formData.grade}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Grade</option>
                  <option value="8th">8th Grade</option>
                  <option value="9th">9th Grade (Freshman)</option>
                  <option value="10th">10th Grade (Sophomore)</option>
                  <option value="11th">11th Grade (Junior)</option>
                  <option value="12th">12th Grade (Senior)</option>
                </select>
              </div>
            </div>
          </div>

          {/* Parent/Guardian Information */}
          <div className="form-section-dark">
            <h2>Parent/Guardian Information</h2>
            <div className="form-grid-dark">
              <div className="form-group-dark">
                <label htmlFor="parentName">Full Name *</label>
                <input
                  type="text"
                  id="parentName"
                  name="parentName"
                  value={formData.parentName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group-dark">
                <label htmlFor="parentEmail">Email *</label>
                <input
                  type="email"
                  id="parentEmail"
                  name="parentEmail"
                  value={formData.parentEmail}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group-dark">
                <label htmlFor="parentPhone">Phone *</label>
                <input
                  type="tel"
                  id="parentPhone"
                  name="parentPhone"
                  value={formData.parentPhone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>

          {/* Questions */}
          <div className="form-section-dark">
            <h2>About You</h2>
            
            <div className="form-group-dark form-group-full-dark">
              <label htmlFor="positions">What position(s) do you play? *</label>
              <input
                type="text"
                id="positions"
                name="positions"
                value={formData.positions}
                onChange={handleChange}
                placeholder="e.g., Offensive Line, Defensive End"
                required
              />
            </div>

            <div className="form-group-dark form-group-full-dark">
              <label htmlFor="goals">What are your football goals for this off-season? *</label>
              <textarea
                id="goals"
                name="goals"
                value={formData.goals}
                onChange={handleChange}
                rows={4}
                placeholder="Tell us what you want to achieve..."
                required
              />
            </div>

            <div className="form-group-dark form-group-full-dark">
              <label htmlFor="favoritePlayers">Who are some of your favorite players to watch? *</label>
              <input
                type="text"
                id="favoritePlayers"
                name="favoritePlayers"
                value={formData.favoritePlayers}
                onChange={handleChange}
                placeholder="e.g., Quenton Nelson, Zack Martin"
                required
              />
            </div>
            
            {/* Honeypot field - hidden from users, catches bots */}
            <input type="text" name="website" style={{display: 'none'}} tabIndex={-1} autoComplete="off" />
          </div>

          <div className="form-submit-dark">
            <button type="submit" className="btn-submit-dark">
              BEGIN FOOTBALL IQ TEST
            </button>
            <p className="form-note-dark">Test takes approximately 15-20 minutes</p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AssessmentPage;

